import { createFileRoute } from "@tanstack/react-router";
import { RestrictionsPage } from "./-components/RestrictionsPage";

export const Route = createFileRoute(
  "/(restricted)/ejendomstjek/address/$accessAddressId/{-$placeId}/restrictions/{-$currentPlaceId}",
)({
  component: RestrictionsPage,
});
